import { Stack, SxProps, Theme, Typography } from '@mui/material'
import { KButton } from 'components/core/KButton'
import { KTextField } from 'components/core/KTextField'
import { useCurrentStore, usePromoCode } from 'hooks'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface PromotionCodeProps {
  sx?: SxProps<Theme>
}

export const PromotionCode: FC<PromotionCodeProps> = ({ sx }) => {
  const [promoCodeInput, setPromoCodeInput] = useState('')
  const { applyPromoCode, isLoading, isSuccess, errorMessage } = usePromoCode()
  const { store } = useCurrentStore()
  const { t } = useTranslation()

  return (
    <Stack gap={1.5} sx={sx}>
      {store.active_promo_code?.instruction_line_2 && (
        <Typography variant="h3" fontWeight={500}>
          {store.active_promo_code.instruction_line_2}
        </Typography>
      )}
      <KTextField
        label="Promotion Code"
        margin="dense"
        id="promo_code"
        name="promo_code"
        onChange={(e) => setPromoCodeInput(e.target.value)}
        endAdornment={
          <KButton
            size="small"
            onClick={() => applyPromoCode(promoCodeInput)}
            disabled={!promoCodeInput || isLoading}
          >
            {t('APPLY')}
          </KButton>
        }
      />
      {!errorMessage && isSuccess && (
        <Typography variant="h5" color="primary" mt={1}>
          {t('Your code is accepted!')}
        </Typography>
      )}
      {errorMessage && (
        <Typography variant="h5" color="error" mt={1}>
          {t(errorMessage)}
        </Typography>
      )}
    </Stack>
  )
}
